<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <h2 class="mb-2 text-center">Welcome</h2>
    <p class="text-center"><strong>Your account has been set up.</strong></p>

    <p>
      PartnerLists is the only software that enables businesses and professionals build
      their own lead generation network.
    </p>

    <p>
      Getting started is easy.  Add the Pros you do business with every day and start
      making recommendations!
    </p>

    <div class="mt-2 ml-auto mr-auto">
    <v-btn :to="{ name: 'referrals' }" color="primary">Get Started</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
}
</script>
